const priceRangeConvert = (priceRange) => {
    return priceRange.toString().split(',').join(" - ")
}

export default priceRangeConvert;